import styled from 'styled-components';
import { Button as UIButton } from '../../../../Button/styled';
export const Button = styled(UIButton) `
    background: none;
    border: none;
    cursor: pointer;
    right: 3.33%;
    top: 0;
    position: absolute;
    z-index: 4;
`;
//# sourceMappingURL=index.js.map